import { defineStore } from 'pinia'
import { type Component, ref } from 'vue'

export const useModalManagerStore = defineStore('modalManager', () => {
  const modalVisible = ref(false)
  const modalTitle = ref<string>('')
  const modalComponent = ref<Component | null>(null)
  const modalProps = ref<null | Record<string, unknown>>(null)
  const onDelete = ref<(() => void) | null>(null)

  const openModal = (
    component: Component,
    title: string,
    props: Record<string, unknown> = {},
  ): void => {
    modalComponent.value = component
    modalTitle.value = title
    modalProps.value = props
    modalVisible.value = true
  }

  const setOnDelete = (handler: (() => void) | null): void => {
    onDelete.value = handler
  }

  const closeModal = (): void => {
    modalVisible.value = false
    modalComponent.value = null
    modalProps.value = null
    onDelete.value = null
  }

  return {
    closeModal,
    modalComponent,
    modalProps,
    modalTitle,
    modalVisible,
    onDelete,
    openModal,
    setOnDelete,
  }
})
